import axios from 'axios';

const RAPID_API_LAMBDA_URL = process.env.REACT_APP_RAPID_HEALTHCHECK_BASE_URL;
const LOGIN_API_URL = process.env.REACT_APP_RAPID_LOGIN_URL;

export const invokeRapidHealthCheckAPI = async (projectId, clusterId, tabName) => {
  // Retrieve the temporary token we saved during login
  const token = localStorage.getItem('auth_token'); 

  const startTime = performance.now();

  const response = await axios.post(
    RAPID_API_LAMBDA_URL, 
    // 1. The Body (2nd argument in axios.post)
    {
      action: 'healthcheck',
      projectId,
      clusterId,
      tab: tabName,
    },
    // 2. The Config block containing Headers (3rd argument in axios.post)
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '' 
      }
    }
  );
  const endTime = performance.now();
  const nanoseconds = endTime - startTime;
  const seconds = Number(nanoseconds) / 1000;
  console.log(`Query for action healthcheck and tab ${tabName} took ${seconds.toFixed(4)} seconds.\n`);
  
  return response.data?.responseData; 
};

export const invokeRapidModuleManagementAPI = async (projectId, clusterId) => {
  const token = localStorage.getItem('auth_token'); 
  const startTime = performance.now();
  const response = await axios.post(RAPID_API_LAMBDA_URL, {
    action:'moduleManagement',
    projectId,
    clusterId,
    tab:""
  },
  {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '' 
    }
  }
);
  const endTime = performance.now();
  const nanoseconds = endTime - startTime;
  const seconds = Number(nanoseconds) / 1000;
  console.log(`Query for action moduleManagement took ${seconds.toFixed(4)} seconds.\n`);
  return response.data.responseData;
};


export const invokeRapidLoginAPI = async (userName, password) => {

  try {
    const startTime = performance.now();
    const response = await axios.post(
      LOGIN_API_URL, 
      { 
        username: userName, // Matches the adaptable Lambda's expected key
        password 
      },
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );

    // 1. API Gateway/Lambda returns data. If it goes through the Lambda proxy integration,
    // the actual Lambda return object is inside response.data.
    const lambdaResult = response.data;
    
    const endTime = performance.now();
    const nanoseconds = endTime - startTime;
    const seconds = Number(nanoseconds) / 1000;
    console.log(`invokeRapidLoginAPI has actually took ${seconds.toFixed(4)} seconds.\n`);
    let innerBody = {};
    
    // 2. Safely parse the Lambda's stringified body if it exists
    if (lambdaResult && typeof lambdaResult.body === 'string') {
      try {
        innerBody = JSON.parse(lambdaResult.body);
      } catch (e) {
        console.error("Failed to parse inner Lambda body:", e);
      }
    } else if (lambdaResult && typeof lambdaResult.body === 'object') {
      innerBody = lambdaResult.body;
    } else {
      innerBody = lambdaResult || {};
    }

    // 3. Check both the HTTP status from the Gateway and our Lambda logic's status
    const statusCode = lambdaResult?.statusCode || response.status;

    if (statusCode === 200 && innerBody.token) {
      return {
        success: true,
        token: innerBody.token,
        message: innerBody.message || "Login successful",
        user: { name: innerBody.username, role: innerBody.role } // For your onLogin(response.user) layout
      };
    } else {
      return {
        success: false,
        message: innerBody.message || "Invalid username or password"
      };
    }
} catch (error) {
  // Log the error for debugging
  console.error("RapidLogin API Error:", error.response?.data || error.message);

  // Extract the inner message from the Lambda error if available
  let errorMsg = "Unable to connect to authentication service.";
  const errorData = error.response?.data;

  if (errorData && typeof errorData.body === 'string') {
    try {
      const parsedError = JSON.parse(errorData.body);
      errorMsg = parsedError.message || errorMsg;
    } catch(e) {}
  } else if (errorData?.message) {
    errorMsg = errorData.message;
  }

  return {
    success: false,
    message: errorMsg
  };
}
};
